import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const coffee = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Кава та чай'/>
            <main className={s.main}>
                <p>Кава</p>
                <Product name='Еспресо' price='20 грн.'/>
                <Product name='Еспресо з молоком' price='25 грн.'/>
                <Product name='Американо' price='20 грн.'/>
                <Product name='Американо з молоком' price='25 грн.'/>
                <Product name='Капучино' price='35 грн.'/>
                <Product name='Ірландський віскі' price='35 грн.'/>
                <Product name='Флет-вайт' price='40 грн.'/>
                <Product name='Турецька' price='25 грн.'/>
                <Product name='Лате' price='40 грн.'/>
                <Product name='Лате з арахісовою пастою' price='50 грн.' info1='еспресо, молоко, арахісова паста, шоколадний сироп'/>
                <Product name='Італійський бічерін' price='60 грн.' info1='еспресо, молоко, вершки, какао, шоколадні дропси, сироп "Тірамісу", аерозольні вершки'/>
                <Product name='Гарячий апельсин ' price='60 грн.' info1='апельсиновий сік, еспресо, карамельний сироп, паличка кориці'/>
                <Product name='Глясе' price='45 грн.' info1='американо, морозиво, кокосовий сироп, лід'/>
                <Product name='Айс лате' price='40 грн.'/>
                <Product name='Бамбл' price='50 грн.' info1='апельсиновий сік, еспресо, карамельний сироп, лід'/>
                <Product name='Холодний лате з орео' price='70 грн.' info1='молоко, еспресо, шоколадний сироп, вершки, печиво "Орео", топінг, лід'/>
                <Product name='Сироп на вибір' price='5 грн.'/>
                <p>Чаї</p>
                <Product name='Чорнобаївський' price='25 грн.'/>
                <Product name='Нахабний фрукт' price='35 грн.'/>
                <Product name='Зелений ОРА' price='25 грн.'/>
                <Product name='Ягідний коктейль' price='35 грн.'/>
                <Product name='Альпійський луг' price='25 грн.'/>
                <Product name='Королівський манго' price='35 грн.'/>
                <Product name='Барбадоська вишня' price='35 грн.'/>
                <Product name='В пакетиках' price='25 грн.' info1="чорний, зелений, фруктовий та трав'яний"/>
                <p>Добавки</p>
                <Product name='Імбир' price='5 грн.'/>
                <Product name='Лимон' price='10 грн.'/>
                <Product name='Мед' price='10 грн.'/>
            </main>
        </div>
    )
}

export default coffee;